export default __webpack_public_path__ + "static/media/feature-7.6cfa5281.svg";